import { Plus } from 'lucide-react'
import { cn } from '@/lib/utils'
import Button from '@/shared/components/ui/Button';

export interface BankAccount {
    id: string;
    bankName: string;
    accountNumber: string;
    accountHolder: string;
    logo?: string;
}

interface CardBankAccountProps {
    accounts: BankAccount[];
    selectedId?: string;
    onSelect?: (account: BankAccount) => void;
    onAddAccount?: () => void;
    className?: string;
}

const CardBankAccount = ({
    accounts,
    selectedId,
    onSelect,
    onAddAccount,
    className,
}: CardBankAccountProps) => {
    return (
        <article className={cn('shadowCard w-full p-3 flex flex-col gap-3', className)}>
            <h3 className='title2medium'>Pilih Rekening Tujuan</h3>

            <div className="flex flex-col gap-3" role='radiogroup' aria-label='Rekening tujuan'>
                {accounts.map((account) => {
                    const isSelected = account.id === selectedId
                    return (
                        <button
                            key={account.id}
                            type='button'
                            role='radio'
                            aria-checked={isSelected}
                            onClick={() => onSelect?.(account)}
                            className={cn(
                                'w-full inline-flex items-center gap-3 rounded-[12px] border p-3 text-left transition-all',
                                isSelected
                                    ? 'border-text-blue-100 bg-bg-grey-100'
                                    : 'border-blue-cs-200 bg-white'
                            )}
                        >
                            <figure className='w-[40px] h-[40px] shrink-0 rounded-[4px] border border-blue-cs-200 bg-white overflow-hidden flex items-center justify-center'>
                                {account.logo ? (
                                    <img src={account.logo} alt={account.bankName} className='w-full h-full object-contain' />
                                ) : (
                                    <span className='reg12medium uppercase text-text-blue-100'>
                                        {account.bankName.slice(0, 3)}
                                    </span>
                                )}
                            </figure>

                            <div className="min-w-0 flex-1 flex flex-col">
                                <span className='title2medium truncate'>
                                    {account.bankName} {account.accountNumber}
                                </span>
                                <span className='reg12 text-text-grey truncate'>a/n {account.accountHolder}</span>
                            </div>

                            <span
                                className={cn(
                                    'h-5 w-5 shrink-0 rounded-full border-2 flex items-center justify-center transition-all',
                                    isSelected ? 'border-text-blue-100' : 'border-text-grey'
                                )}
                            >
                                {isSelected && <span className='h-2.5 w-2.5 rounded-full bg-text-blue-100' />}
                            </span>
                        </button>
                    )
                })}
            </div>

            <Button
                type='button'
                onClick={onAddAccount}
                className='btn-fill-blue-opacity'
            >
                <Plus size={18} />
                <span className='title3bold'>Tambah rekening bank baru</span>
            </Button>
        </article>
    )
}

export default CardBankAccount
